<template lang="pug">
.input-text
  label.input-text__label(for="field-login-name") Name *
  input.input-text__input(
    id="field-login-name"
    type="text"
    placeholder=""
    v-model.trim="value"
    @change="changeFieldValue()"
    @keyup="changeFieldValue()"
  )
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'FieldName',

  data () {
    return {
      value: ''
    }
  },

  methods: {
    ...mapMutations([
      'changeField'
    ]),

    changeFieldValue () {
      this.changeField({
        name: 'fieldName',
        value: this.value
      })
    }
  }
}
</script>
